import { Project } from './project.interface';

export interface ProjectState {
  sortType: string;
  list: Array<Project>;
  total: number;
  displayAmt: number;
}
